<ng-container *ngIf="items$ | async">
  <div class="ref-carousel-wrapper" *ngIf="itemsNonUpselling$[idString] as items">
    <!-- CROSS SELLING / COMPATIBLE Template -->
    <div class="container" *ngIf="items.length > 0">
      <label>{{ p_title$ | async }}</label>
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
        <div ngxSlickItem *ngFor="let item of items; let i = index" class="slide">
          <div class="item" *ngIf="item | async as data">
            <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
              <div class="prod-image">
                <div>
                  <cx-media
                    [container]="getImageRendition(data['images']?.PRIMARY, 'default')"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                  ></cx-media>
                </div>
              </div>
              <div class="prod-body">
                <div class="prod-code">{{ data['code'] }}</div>
                <div class="prod-name" [innerHTML]="data['name']"></div>
                <div class="prod-price" *ngIf="showSrp">
                  <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                  <span class="p-price"
                    >{{ data['srpPrice']?.formattedValue
                    }}<span class="gst-label" *ngIf="data['srpPrice']?.formattedValue && showGstInclusive$ | async">{{
                      'productCarousel.gstInclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
                <ng-container *ngIf="!showSrp">
                  <div class="prod-price">
                    <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                    <span class="p-price">
                      <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data['code']); else dealerPriceReady">
                        <ng-container *ngIf="tooltipIconConfigNotUpselling$ | async as tooltipIconConfigNotUpselling">
                          <div class="spinner-shimano spinner-shimano-mr" *ngIf="hasDealerPrice">
                            <div></div>
                          </div>
                          <div
                            class="no-dealer-price no-dealer-price-cs-cm"
                            *ngIf="
                              !hasDealerPrice && !tooltipIconConfigNotUpselling?.enabled;
                              else noDealerPriceTooltipNotUpselling
                            "
                          ></div>
                          <ng-template #noDealerPriceTooltipNotUpselling>
                            <app-tooltip-icon
                              *ngIf="!hasDealerPrice && tooltipIconConfigNotUpselling?.enabled"
                              [noDealerPriceIcon]="tooltipIconConfigNotUpselling?.noDealerPriceIcon"
                              dealerPriceIconContainerClass="no-dealer-price-upsell"
                              [uniqueClass]="data['code']"
                              placement="bottom-right"
                              [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                              [closeOnScroll]="tooltipIconConfigNotUpselling?.closeOnScroll"
                              [noPointerEventsOnElement]="tooltipIconConfigNotUpselling?.noPointerEventsOnElement"
                              [handleEvents]="tooltipIconConfigNotUpselling?.handleEvents"
                            ></app-tooltip-icon>
                          </ng-template>
                        </ng-container>
                      </div>
                      <ng-template #dealerPriceReady>
                        {{ dealerPrice(data['code'])
                        }}<span class="gst-label" *ngIf="dealerPrice(data['code']) && showGstExclusive$ | async">{{
                          'productCarousel.gstExclusive' | cxTranslate
                        }}</span>
                      </ng-template>
                    </span>
                  </div>
                </ng-container>
              </div>
            </a>
            <div class="prod-bottom container">
              <div class="row">
                <div class="col-sm-6">
                  <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
                    <mat-icon class="material-icons-sharp light">assignment</mat-icon>
                  </a>
                </div>
                <div class="col-sm-6">
                  <a tabindex="0" type="button" class="order-form" (click)="addToCart(data['code'])">
                    <mat-icon class="material-icons-sharp light">note_add</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>

  <ng-container *ngIf="itemsUpselling$[idString] as itemsUpselling">
    <!-- UPSELLING Template -->
    <div class="upselling-wrapper" *ngIf="itemsUpselling.length && itemsUpselling[0] | async as item">
      <div class="container">
        <div class="ref-box">
          <div class="ref-title">{{ p_title$ | async }}</div>
          <div class="ref-item">
            <a tabindex="0" (click)="goToPdp(item, $event, 1)">
              <div class="prod-image">
                <div>
                  <cx-media
                    [container]="getImageRendition(item?.images?.PRIMARY, 'upsell')"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                  ></cx-media>
                </div>
              </div>
              <div class="prod-body">
                <div class="prod-name" [innerHTML]="item?.name"></div>
                <div class="prod-price" *ngIf="!showSrp">
                  <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                  <span class="p-price">
                    <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(item?.code); else dealerPriceReady">
                      <ng-container *ngIf="tooltipIconConfigUpselling$ | async as tooltipIconConfigUpselling">
                        <div class="spinner-shimano" *ngIf="hasDealerPrice">
                          <div></div>
                        </div>
                        <div
                          class="no-dealer-price no-dealer-price-upsell"
                          *ngIf="
                            !hasDealerPrice && !tooltipIconConfigUpselling?.enabled;
                            else noDealerPriceTooltipUpselling
                          "
                        ></div>
                        <ng-template #noDealerPriceTooltipUpselling>
                          <app-tooltip-icon
                            *ngIf="!hasDealerPrice && tooltipIconConfigUpselling?.enabled"
                            [noDealerPriceIcon]="tooltipIconConfigUpselling?.noDealerPriceIcon"
                            dealerPriceIconContainerClass="no-dealer-price-upsell"
                            [uniqueClass]="item?.code"
                            placement="bottom-right"
                            [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                            [closeOnScroll]="tooltipIconConfigUpselling?.closeOnScroll"
                            [noPointerEventsOnElement]="tooltipIconConfigUpselling?.noPointerEventsOnElement"
                            [handleEvents]="tooltipIconConfigUpselling?.handleEvents"
                          ></app-tooltip-icon>
                        </ng-template>
                      </ng-container>
                    </div>
                    <ng-template #dealerPriceReady>
                      {{ dealerPrice(item?.code)
                      }}<span class="gst-label" *ngIf="dealerPrice(item?.code) && showGstExclusive$ | async">{{
                        'gst.exclusive' | cxTranslate
                      }}</span>
                    </ng-template>
                  </span>
                </div>
                <div class="prod-price" *ngIf="showSrp">
                  <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                  <span class="p-price" *ngIf="item?.srpPrice"
                    >{{ item.srpPrice.formattedValue
                    }}<span class="gst-label" *ngIf="item?.srpPrice?.formattedValue && showGstInclusive$ | async">{{
                      'gst.inclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
